import React, { ReactElement } from "react";
import Lottie from "lottie-react";
import chamberLoadingAnimation from "../../../images/chamberloading.json";

interface LoaderProps {
  size?: number;
  fullPage?: boolean;
}

const Loader = ({ size = 300, fullPage = true }: LoaderProps): ReactElement => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        ...(fullPage ? { height: "100vh" } : { padding: "20px 0" }),
      }}
    >
      <Lottie
        animationData={chamberLoadingAnimation}
        loop
        autoplay
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export default Loader;
